export default __webpack_public_path__ + "static/media/gilroy-semibold.e38937db.woff";